import { createContext, ReactNode, RefObject, useContext, useRef } from 'react';
import { SelectInstance } from 'react-select';

type RefObjectType<OptionType = unknown, IsMulti extends boolean = boolean> = SelectInstance<OptionType, IsMulti> & {
  id?: string;
};

export interface AutoFocusContextType<OptionType = unknown, IsMulti extends boolean = boolean> {
  focus: () => void;
  ref: RefObject<RefObjectType<OptionType, IsMulti>> | null;
}

export const AutoFocusContext = createContext<AutoFocusContextType>({
  focus: () => {
    return;
  },
  ref: null,
});

interface Props {
  children: ReactNode;
}

export const AutoFocusContextProvider = (props: Props) => {
  const ref = useRef<SelectInstance<unknown, boolean>>(null);
  const focus = () => {
    setTimeout(() => {
      if (ref.current?.focus) {
        ref.current.focus();
      }
    }, 200);
  };

  return <AutoFocusContext.Provider value={{ ref, focus }}>{props.children}</AutoFocusContext.Provider>;
};

// The reference to react-select component may require specifying option type generic,
// this hook allows to assert the type
export function useAutoFocus<OptionType = unknown, IsMulti extends boolean = boolean>() {
  return useContext(AutoFocusContext) as unknown as AutoFocusContextType<OptionType, IsMulti>;
}
